class Accordion {
  constructor() {
    this.accordionClass = '.accordion';
    this.accordionHeaderClass = 'accordion__item-button';
    this.openTabClass = 'accordion__item-button--expanded';
  }

  events() {
    window.addEventListener('resize', () => {
      const accordions = document.querySelectorAll(this.accordionClass);

      accordions.forEach((accordion) => {
        const expandedButton = accordion.querySelector(`.${this.openTabClass}`);
        if (expandedButton) {
          const content = expandedButton.parentElement.nextElementSibling;
          if (content) {
            content.style.height = 'auto';
            content.style.height = `${content.scrollHeight}px`;
          }
        }
      });
    });
  }

  init() {
    const accordions = document.querySelectorAll(`section${this.accordionClass}`);
    accordions.forEach((accordion) => this.setupAccordion(accordion));
  }

  setupAccordion(accordion) {
    const { hash } = window.location;
    const buttons = accordion.querySelectorAll(`.${this.accordionHeaderClass}`);

    if (buttons.length === 0) {
      return;
    }

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => this.toggleAccordion(e));
      button.addEventListener('touchend', (e) => this.toggleAccordion(e));
      button.addEventListener('keydown', (e) => this.handleKeyboard(e));

      if (hash && button.id === hash.substring(1)) {
        button.click();
      }
    });
  }

  handleKeyboard(event) {
    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.toggleAccordion(event);
        break;
      default:
        break;
    }
  }

  toggleAccordion(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const content = button.parentElement.nextElementSibling;
    const isExpanded = Accordion.ariaUpdater(button);

    if (isExpanded) {
      this.collapseAccordion(button, content);
    } else {
      this.expandAccordion(button, content);
    }
  }

  expandAccordion(button, content) {
    if (!button.classList.contains(this.openTabClass)) {
      this.collapseCurrent();
    }

    button.classList.add(this.openTabClass);
    Accordion.updateContentHeight(content, true);
  }

  collapseCurrent() {
    const openButtons = document.querySelectorAll(`.${this.openTabClass}`);

    openButtons.forEach((openButton) => {
      const openContent = openButton.parentElement.nextElementSibling;

      if (openContent) {
        openButton.classList.remove(this.openTabClass);
        openButton.setAttribute('aria-expanded', 'false');
        Accordion.updateContentHeight(openContent, false);
      }
    });
  }

  collapseAccordion(button, content) {
    button.classList.remove(this.openTabClass);
    Accordion.updateContentHeight(content);
  }

  static updateContentHeight(content, expand = false) {
    if (expand) {
      content.classList.add('accordion__item-body--expanded');
    } else {
      content.classList.remove('accordion__item-body--expanded');
    }

    const height = expand ? content.scrollHeight : 0;
    // eslint-disable-next-line no-param-reassign
    content.style.height = `${height}px`;
  }

  static ariaUpdater(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);

    return isExpanded;
  }
}

const AccordionObj = new Accordion();
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    AccordionObj.init();
    AccordionObj.events();
  }, 0);
});
